import React from "react";
import { Outlet } from "react-router-dom";
import TopBar from "./Layout/TopBar";
import "./App.scss";

function App() {
  return (
    <div className="app">
      <TopBar />
      <div className="sunset-banner" role="note" aria-label="Anaconda Toolbox sunset notice">
        <strong>The Anaconda Toolbox Excel add-in will stop working on April 30, 2027</strong>
        <p>Cells using =ANACONDA.CODE() will no longer be able to recalculate after the add-in is retired.</p>
        <p>Python in Excel’s =PY() formulas are unaffected by this retirement.</p>
      </div>
      <div className="content">
        {/* https://reactrouter.com/en/main/components/outlet */}
        <Outlet />
      </div>
    </div>
  );
}

export default App;
